export default {
  title: 'Oletko varma?',
  description: 'Seuraavat muokkainryhmät (mukaan lukien niiden muokkaimet) poistetaan:',
  buttons: {
    yes: 'Kyllä',
    no: 'Ei',
  },
  toasts: {
    modifier_group_got_deleted: 'Muokkausryhmät poistettiin',
    failed_to_delete_modifier_group: 'Muokkausryhmän poistaminen epäonnistui',
  },
};
